import styled from "styled-components";

export const PageWrapper = styled.div`
  background: #eef3f9;
  min-height: 100vh;
  padding: 100px 16px 80px;

  @media (min-width: 800px) {
    padding-top: 120px;
  }
`;

export const Content = styled.div`
  max-width: 1000px;
  margin: 0 auto;

  > h3 {
    margin: 16px 0 12px;
    color: #101828;
    font-size: 18px;
    font-weight: 800;
  }

  .upload-complete-message {
    margin: 16px 0 0;
    padding: 12px 14px;
    border: 1px solid #bbf7d0;
    border-radius: 10px;
    background: #f0fdf4;
    color: #15803d;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 800;
  }

  .upload-complete-message svg {
    width: 18px;
    height: 18px;
  }
`;

export const OrderHeader = styled.div`
  background: #ffffff;
  margin: 0 0 16px;
  padding: 1rem;
  border: 1px solid #dce4ef;
  border-radius: 12px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.06);
  display: flex;
  align-items:center;
  justify-content: space-between;
  gap: 14px;

  .order-sub-container {
    display: flex;
    align-items: center;
  }
  
  .order-number {
    font-size: 16px;
    margin: 0;
    color: #101828;
    font-weight: 800;
  }

  .order-icons {
    margin-right: 10px;
    font-size: 16px;
  }

  .created-at {
    color: #495565;
    font-size: 12px;
    margin-top: 2px;
  }

  .awb-container {
    font-size: 12px;
  }

  .awb {
    font-weight: 700;
  }

  @media(min-width: 600px){
    padding: 1.5rem;

    .order-number {
      font-size: 20px;
    }

    .order-icons {
      font-size: 20px;
    }

    .created-at {
      font-size: 14px;
      margin-top: 6px;
    }
    .awb-container {
      font-size: 14px;
    }
  }
`;

export const ProductCard = styled.div`
  background: #ffffff;
  margin: 16px 0;
  padding: 16px;
  border: 1px solid #dce4ef;
  border-radius: 12px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.05);

  .product-detail-container {
    display: grid;
    grid-template-columns: 120px minmax(0, 1fr);
    gap: 14px;
    align-items: start;
  }

  .product-image-container {
    width: 86px;
    height: 86px;
    margin-right: 0;
  }

  .side-heading {
    color: #6A7282;
  }

  .detail-value {
    color: #111828;
  }

  .product-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-fit-position: center;
    border-radius: 10px;
    background: #eef3f9;
  }

  .details {
    margin-top: 6px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px 14px;
    font-size: 13px;

    .product-title {
      font-size: 16px;
      color: #111828;
    }
  }

  .product-title {
    margin: 0;
    color: #111828;
    font-size: 16px;
    line-height: 1.3;
    font-weight: 800;
  }

  .details-wrapper {
    width: 100%;
  }

  @media (min-width: 800px){
    .product-image-container {
      width: 112px;
      height: 112px;
    }

    .details {
      font-size: 14px;

      .product-title {
        font-size: 20px;
      }
    }
  }
`;

export const UploadZone = styled.label`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1.5px dashed ${(props) => props.primary_theme_color || "#2563eb"};
  border-radius: 12px;
  padding: 14px;
  text-align: center;
  cursor: pointer;
  color: ${(props) => props.primary_theme_color || "#2563eb"};
  background: #f8fbff;
  margin-top: 14px;
  transition: background 160ms ease, border-color 160ms ease;

  &:hover {
    background: #f1f7ff;
  }

  .upload-icon {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
  }

  .upload-title {
    color: #101828;
    font-weight: 800;
  }

  .upload-subtitle {
    margin-top: 3px;
    color: #64748b;
    font-size: 12px;
  }

  span {
    font-size: 14px;
  }

  @media (min-width: 800px){
    padding: 20px;
    margin-top: 1rem;
    span {
      font-size: 16px;
    }
  }
`;

export const UploadButton = styled.button`
  margin: 24px auto;
  display: block;
  padding: 14px 24px;
  background-color: ${(props) => props.primary_theme_color};
  color: #fff;
  border: none;
  border-radius: ${(props) => props.rounded ? "10px" : "0px"};
  cursor: pointer;
  width: 100%;
  font-size: 15px;
  font-weight: 800;
  box-shadow: 0 12px 24px rgba(37, 99, 235, 0.16);
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
  height: 8px;
  margin-top: 4px;
`;

export const Progress = styled.div`
  background: ${(props) => props.primary_theme_color};
  height: 8px;
  width: ${(props) => props.value}%;
  transition: width 0.2s ease;
`;

export const PreviewList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
`;

export const PreviewItem = styled.div`
  position: relative;
  border: 1px solid #d6e0ec;
  background: #f8fafc;
  border-radius: 10px;
  width: 112px;
  overflow: hidden;
  font-size: 12px;

  .preview-remove {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.72);
    color: #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    z-index: 2;
  }

  .preview-remove svg {
    width: 16px;
    height: 16px;
  }

  .preview-meta {
    padding: 8px;
    color: #475467;
  }

  .preview-meta p {
    margin: 0;
    color: #101828;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .preview-meta span {
    display: block;
    margin-top: 3px;
    font-size: 11px;
  }

  &.preview-add-tile {
    min-height: 146px;
    border: 1.5px dashed #9db4d1;
    background: #f8fbff;
    color: #2563eb;
    cursor: pointer;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-weight: 800;
  }

  &.preview-add-tile svg {
    width: 28px;
    height: 28px;
  }
`;

export const Thumb = styled.img`
  width: 100%;
  height: 104px;
  object-fit: cover;
  display: block;
  background: #e2e8f0;
`;

export const VideoThumb = styled.video`
  width: 100%;
  height: 104px;
  object-fit: cover;
  display: block;
  background: #0f172a;
`;
